import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';

const apiUrl = environment.apiUrl;
const branchIoUrl = environment.branchIoUrl;
const branchKey = environment.branchKey;

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private http: HttpClient
  ) {
  }

  public call = (method: string, url: string, body?) => {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.request(method, apiUrl + url, {body, headers});
  }
  public callToken = (method: string, url: string) => {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.request(method, apiUrl + url, {headers, observe: 'response'});
  }

  public getAppClipsBuilding = (id) => this.call('GET', `public/apartments/building-group-by-name/${id}`);

  public getAppClipsBuildingOld = (id) => this.call('GET', `public/apartments/building-group/${id}`);

  public getAppClipsApartments = (id) => this.call('GET', `public/apartments/building-group-by-name/${id}/apartments`);

  public getAppClipsApartmentsOld = (id) => this.call('GET', `public/apartments/building-group/${id}/apartments`);

  public getBranchLink = (unitId) => {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.request('POST', branchIoUrl, {body: {branch_key: branchKey, feature: 'self-showing', data: {
          unitId,
        }}, headers});
  }

  public sendSMS = (body, token) => {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json'
    }).set('sms-token', [token]);
    return this.http.request('POST', `${apiUrl}public/sms-link`, {body, headers, observe: 'response'});
  }

  public getSmsToken = () => this.callToken('GET', 'public/sms-link/token');
}
